import { CookieConsentActionTypes } from '../../../enums/ActionEnums';
const cookieConsentActions = {
    createClearAction() {
        return {
            type: CookieConsentActionTypes.CLEAR,
        };
    },
    createSetAction(payload) {
        return {
            type: CookieConsentActionTypes.SET,
            payload,
        };
    },
};
export default cookieConsentActions;
